import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal right fade",
  id: "myModal2",
  tabindex: "-1",
  "aria-labelledby": "myModalLabel2",
  style: {"display":"block"},
  "data-bs-keyboard": "false",
  "data-bs-backdrop": "static"
}
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = {
  id: "myModalLabel2",
  style: {"background-color":"#0054a6","color":"white"}
}
const _hoisted_6 = { class: "modal-body" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "body" }
const _hoisted_9 = { class: "customSettingName" }
const _hoisted_10 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_11 = { class: "input-group mb-3" }
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = { class: "tktTex" }
const _hoisted_14 = {
  for: "basic-url",
  style: {"font-size":"16px"}
}
const _hoisted_15 = { class: "input-group mb-3" }
const _hoisted_16 = { class: "form-check form-check-inline" }
const _hoisted_17 = {
  class: "form-check-label",
  for: "inlineRadio1"
}
const _hoisted_18 = { class: "form-check form-check-inline" }
const _hoisted_19 = {
  class: "form-check-label",
  for: "inlineRadio2"
}
const _hoisted_20 = { class: "allowance" }
const _hoisted_21 = {
  class: "form-check-label",
  for: "customRange3",
  style: {"font-size":"16px"}
}
const _hoisted_22 = { style: {"position":"absolute","right":"20px"} }
const _hoisted_23 = { class: "defaultSetting mt-3" }
const _hoisted_24 = { class: "form-check form-check-inline" }
const _hoisted_25 = {
  class: "form-check-label",
  for: "inlineCheckBox3"
}
const _hoisted_26 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertComponent = _resolveComponent("AlertComponent")!

  return (_ctx.show)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "close",
                "aria-label": "Close",
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleDialogClose && _ctx.handleDialogClose(...args)), ["prevent"]))
              }, [...(_cache[11] || (_cache[11] = [
                _createElementVNode("span", { "aria-hidden": "true" }, [
                  _createElementVNode("i", {
                    class: "fa fa-times",
                    "aria-hidden": "true"
                  })
                ], -1)
              ]))]),
              _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.Title), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                (_ctx.isCancelButtonClicked)
                  ? (_openBlock(), _createBlock(_component_AlertComponent, {
                      key: 0,
                      onSetWindow: _cache[1] || (_cache[1] = ($event: any) => ((_ctx.$emit('visibleDialog', false), (_ctx.show = false), _ctx.backdropClose()))),
                      isCancelButtonClicked: _ctx.isCancelButtonClicked,
                      onHidePopup: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isCancelButtonClicked = false))
                    }, null, 8, ["isCancelButtonClicked"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("label", _hoisted_10, _toDisplayString(_ctx.$t("addCustomSetting.name")), 1),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkCustomSettingName && _ctx.checkCustomSettingName(...args))),
                        class: _normalizeClass(["form-control", { errorStyle: _ctx.customSettingNameError }]),
                        id: "basic-url",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newCustomSetting.name) = $event)),
                        maxlength: 20,
                        placeholder: _ctx.placeholder,
                        style: {"border-radius":"10px"},
                        "aria-describedby": "basic-addon3"
                      }, null, 42, _hoisted_12), [
                        [_vModelText, _ctx.newCustomSetting.name]
                      ])
                    ]),
                    _createElementVNode("span", {
                      class: _normalizeClass(["counter", { errorCounter: _ctx.customSettingNameCountError }])
                    }, _toDisplayString(_ctx.newCustomSetting?.name?.length) + "/20", 3)
                  ]),
                  (_ctx.customSettingNameCountError)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ errorCounter: _ctx.customSettingNameCountError })
                      }, _toDisplayString(_ctx.$t("addCustomSetting.settingNameCanHaveMaximum20Character")), 3))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.$t("addCustomSetting.tktTex")), 1),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          name: "inlineRadioOptions",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newCustomSetting.tktTex) = $event)),
                          id: "inlineRadio1",
                          value: "Tkt",
                          checked: ""
                        }, null, 512), [
                          [_vModelRadio, _ctx.newCustomSetting.tktTex]
                        ]),
                        _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("addCustomSetting.tkt")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _withDirectives(_createElementVNode("input", {
                          class: "form-check-input",
                          type: "radio",
                          name: "inlineRadioOptions",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newCustomSetting.tktTex) = $event)),
                          id: "inlineRadio2",
                          value: "Tex"
                        }, null, 512), [
                          [_vModelRadio, _ctx.newCustomSetting.tktTex]
                        ]),
                        _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.$t("addCustomSetting.tex")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("addCustomSetting.allowance")), 1),
                    _createElementVNode("output", _hoisted_22, _toDisplayString(_ctx.newCustomSetting.defaultAllowance) + "%", 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "range",
                      class: "custom-range",
                      min: "0",
                      max: "50",
                      step: "1",
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newCustomSetting.defaultAllowance) = $event)),
                      id: "customRange3"
                    }, null, 512), [
                      [_vModelText, _ctx.newCustomSetting.defaultAllowance]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _withDirectives(_createElementVNode("input", {
                        class: "form-check-input",
                        type: "checkbox",
                        name: "inlineRadioOptions",
                        id: "inlineCheckBox3",
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isDefaultCustomSetting) = $event)),
                        style: {"border":"1px solid black"}
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.isDefaultCustomSetting]
                      ]),
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t("addCustomSetting.setAsMyDefaultSetting")), 1)
                    ])
                  ]),
                  _cache[12] || (_cache[12] = _createElementVNode("hr", { style: {"width":"100%","text-align":"left","margin-left":"0"} }, null, -1)),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-primary mt-2",
                      style: {"width":"7rem","border-radius":"4px"},
                      onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onSave && _ctx.onSave(...args)))
                    }, _toDisplayString(_ctx.$t("operationCreateComp.save")), 1),
                    _createElementVNode("button", {
                      class: "btn btn-sm btn-secondary mt-2",
                      style: {"width":"8rem","border-radius":"4px","margin-left":"10px"},
                      onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.handleDialogClose && _ctx.handleDialogClose(...args)))
                    }, _toDisplayString(_ctx.$t("operationCreateComp.cancel")), 1)
                  ])
                ])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}